/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { ConfirmEmailRequest } from '../models/ConfirmEmailRequest';
import type { OkResult } from '../models/OkResult';
import type { UpdateEmailRequest } from '../models/UpdateEmailRequest';
import type { UpdatePasswordRequest } from '../models/UpdatePasswordRequest';
import type { UpdatePhoneNumberRequest } from '../models/UpdatePhoneNumberRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileService {
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiProfileUpdateEmail(
    requestBody?: UpdateEmailRequest,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/update-email',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiProfileUpdateSecondaryEmail(
    requestBody?: UpdateEmailRequest,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/update-secondary-email',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static postApiProfileConfirmEmail(
    requestBody?: ConfirmEmailRequest,
  ): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/confirm-email',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns AuthResponse OK
   * @throws ApiError
   */
  public static postApiProfileConfirmSecondaryEmail(
    requestBody?: ConfirmEmailRequest,
  ): CancelablePromise<AuthResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/confirm-secondary-email',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiProfileUpdatePhoneNumber(
    requestBody?: UpdatePhoneNumberRequest,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/update-phone-number',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns OkResult OK
   * @throws ApiError
   */
  public static postApiProfileUpdateUserPassword(
    requestBody?: UpdatePasswordRequest,
  ): CancelablePromise<OkResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Profile/update-user-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
}
